/**
 * Developer utility to reset all onboarding and tour flags for clean testing.
 * This clears localStorage flags and resets the user's onboarding state.
 */
import { resetOnboardingState } from '@/hooks/useOnboardingStateMachine';
import { resetTourFlags } from '@/hooks/useTourController';

const ONBOARDING_FLAGS = [
  // Current canonical keys
  'therappi_pre_auth_welcome_seen',
  'therappi_tour_completed',
  // Legacy keys (kept for thorough cleanup)
  'therappi_pre_auth_typewriter_seen',
  'therappi_conversational_completed',
  'therappi_conversational_onboarding_completed',
  'therappi_conversational_onboarding_just_completed',
  'therappi-first-time-tour-seen',
  'therappi_tour_requested',
  'therappi_welcome_seen',
  'therappi-pre-auth-welcome-seen',
  'therappi-tour-requested',
];

export function resetOnboardingFlags(): void {
  console.log('[DEV] Resetting onboarding flags...');
  
  // 1. Reset module-level state machine (CRITICAL - this was missing!)
  resetOnboardingState();
  resetTourFlags();
  console.log('[DEV] State machine reset');
  
  // 2. Clear all known onboarding-related localStorage keys
  ONBOARDING_FLAGS.forEach(key => {
    const keysToRemove = Object.keys(localStorage).filter(
      k => k.startsWith(key) || k === key
    );
    keysToRemove.forEach(k => {
      console.log(`[DEV] Clearing: ${k}`);
      localStorage.removeItem(k);
    });
  });
  
  // 3. Also clear any welcome_seen keys with path suffixes
  Object.keys(localStorage).forEach(key => {
    if (key.includes('welcome_seen') || key.includes('tour') || key.includes('onboarding')) {
      console.log(`[DEV] Clearing: ${key}`);
      localStorage.removeItem(key);
    }
  });
  
  console.log('[DEV] All onboarding flags cleared. Reload the app to test fresh flow.');
}

// Expose to window for console access
if (typeof window !== 'undefined') {
  (window as unknown as { resetOnboardingFlags: typeof resetOnboardingFlags }).resetOnboardingFlags = resetOnboardingFlags;
}
